export default "__VITE_ASSET__BeIUT$0A__"